import React, { useState, useRef, useEffect } from "react";
import "../musicplayer/musicplayer.css";
import { Play, Pause } from "../../assets/SvgIcons";

const getSrc     = (t) => t.audio_file || t.src || "";
const getArtwork = (t) => t.cover_image || t.artwork || null;
const getArtist  = (t) => t.artist || "";
const getTitle   = (t) => t.title || t.trackTitle || "";

const TransparentCard = ({ tracks = [] }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const onEnded = () => {
      if (currentTrackIndex < tracks.length - 1) {
        handleTrackChange(currentTrackIndex + 1);
      } else {
        setIsPlaying(false);
        audio.pause();
      }
    };

    audio.addEventListener("ended", onEnded);
    return () => audio.removeEventListener("ended", onEnded);
  }, [currentTrackIndex, tracks]);

  const togglePlayPause = (index) => {
    const audio = audioRef.current;
    if (!audio) return;
    if (currentTrackIndex === index) {
      isPlaying ? audio.pause() : audio.play();
      setIsPlaying(!isPlaying);
    } else {
      handleTrackChange(index);
    }
  };

  const handleTrackChange = (index) => {
    setCurrentTrackIndex(index);
    setIsPlaying(false);
    if (audioRef.current) {
      audioRef.current.pause();
      setTimeout(() => audioRef.current.play(), 0);
      setIsPlaying(true);
    }
  };

  if (tracks.length === 0) return null;

  const current = tracks[currentTrackIndex] || {};

  return (
    <>
      <audio ref={audioRef} src={getSrc(current)} preload="metadata" />
      {tracks.map((track, index) => (
        <div
          className={`transparent-card ${currentTrackIndex === index ? "active" : ""}`}
          key={track.id || index}
        >
          <div className="transparent-img">
            {getArtwork(track) && (
              <img src={getArtwork(track)} alt={getTitle(track)} />
            )}
          </div>
          <div className="transparent-card__content">
            <h3>{getArtist(track)}</h3>
            <p>{getTitle(track)}</p>
          </div>
          <div className="transparent-svg" onClick={() => togglePlayPause(index)}>
            {isPlaying && currentTrackIndex === index ? <Play /> : <Pause />}
          </div>
        </div>
      ))}
    </>
  );
};

export default TransparentCard;
